import React, { useEffect, useRef, useState } from 'react'
import RoundedInput from "../../components/UI/Cards/Automations/EditAutomations/RoundedInput"

import classes from "../../components/UI/Cards/Automations/EditAutomations/ScheduledAction.module.css"
import SaveButtonclass from "../../components/UI/Cards/Automations/CreateRule/SelectOutputs"
import Button2 from '../../components/UI/Button/Button2';
import { updateScheduleApi } from '../../Api Methods/Api';
import { useDispatch } from 'react-redux';
import { unparse } from 'papaparse';

const EditScheduledAction = React.forwardRef(({ site, siteDevices, setSiteDevices, body, pins, closeModal, apiData}, ref) => {
    const dispatch = useDispatch();

    let currentlySetTime;
    let currentlySetTimeArray;

    // spilt time into hours and minutes, to populate displayed time. For edit view
    if (body && body.time != "") {
        currentlySetTime = body.time;
        currentlySetTimeArray = currentlySetTime.split(":");
    }
    const [daysSelected, setdaysSelected] = useState(JSON.parse(body.days) || []);
    const [pinsSelected, setPinsSelected] = useState(JSON.parse(body.pins) || []);
    const [isAutoArmed, setIsAutoArmed] = useState(body.action == "Disarm" ? false : true || false);
    const [isAutomationActive, setIsAutomationActive] = useState(body.active || 1);
    const [hour, setHour] = useState(currentlySetTimeArray && currentlySetTimeArray[0] || '12');
    const [minutes, setMinutes] = useState(currentlySetTimeArray && currentlySetTimeArray[1] || "00");

    //edit state
    const [editTime, setEditTime] = useState(false)

    useEffect(() => {
    }, [])


    const HandelOnClick = () => {

        const actionString = HandlePrepareAction();
        const isActive = HandlePrepareIsActive();
        const time = HandlePrepareTime();

        if (time == "00:00"){
            //error
        }

        const Body = { ...body, days: daysSelected, time: time, active: isActive, action: actionString }
        UpdateSchedule(Body)
    }

    const UpdateSchedule = async (body) => {
        const response = await updateScheduleApi(apiData, body, dispatch);
        if (response && response.success) {
            closeModal()

            const updatedParsedSchedules = site.parsedScheduledActions.map((schedule) =>
                schedule.id === body.id ? { 
                    id: body.id, 
                    days: JSON.stringify(body.days),
                    pins: body.pins,
                    time: body.time,
                    action: body.action,
                    active: body.active,
                    dateCreated: Date.now()
                } : schedule
            );
                
            const updatedSite = {
                ...site,
                parsedScheduledActions: updatedParsedSchedules
            };

            setSiteDevices((prevSiteDevices) =>
                prevSiteDevices.map((device) =>
                    device.id === site.id ? updatedSite : device
                )
            );
        }
    }

    const HandlePrepareTime = () => {

        if (hour == "00" && minutes == "00"){
            return "23:59";
        }

        return hour + ":" + minutes;
    }


    const HandlePrepareIsActive = () => {
        return + isAutomationActive; // returns 1 if isAutomationActive is true, and 0 if it's false, regardless of its initial type.
    }

    const HandlePrepareAction = () => {
        return isAutoArmed ? "Arm" : "Disarm";
    }

    const HandleResetAllStates = () => {
        setIsAutoArmed(true)

        setIsAutomationActive(false)
        setEditTime(false)
        setHour(currentlySetTimeArray[0]);
        setMinutes(currentlySetTimeArray[1]);
    }

    // Expose the method to the parent component using ref
    React.useImperativeHandle(ref, () => ({
        HandleResetAllStates: HandleResetAllStates
    }));

    const HandleOnDayClicked = (dayIndex) => {
        const isDayAlreayClicked = daysSelected.find(Day => Day == dayIndex);

        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const addItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];
        // // Push the new item to the copy
        newArray.push(dayIndex);

        // // Set the state with the new array
        setdaysSelected(newArray);

    };

    const removeItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];

        const filterArray = newArray.filter(Day => Day !== dayIndex)

        // Set the state with the new array
        setdaysSelected(filterArray);
    }

    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];


    // ---------------------------- Set Time Logic ------------------------------------------
    useEffect(() => {

        // if the hour input is left blank - repopulate it with previous value
        if (hour == "" || hour == null || hour == undefined) {
            setHour(currentlySetTimeArray[0]);
        }

        // if the Minutes input is left blank - repopulate it with previous value
        if (minutes == "" || minutes == null || minutes == undefined) {
            setMinutes(currentlySetTimeArray[0]);
            setMinutes(currentlySetTimeArray[1]);
        }

        const hourAsString = hour.toString(); // Convert number to string
        const hourAsStringLength = hourAsString.length;

        //if 00:00 set to 23:59


        // make sure hour are not 1 but 01
        if (hourAsStringLength < 2) {
            const newHour = 0 + hour
            setHour(newHour);
        }

        const minutesAsString = minutes.toString(); // Convert number to string
        const minutesAsStringLength = minutesAsString.length;
        // make sure minutes are not 1 but 01
        if (minutesAsStringLength < 2) {
            const newHour = 0 + minutes
            setMinutes(newHour);
        }

        if (hourAsString == "00" && minutesAsString == "00"){
            //invalid
            setHour(23);
            setMinutes(59);
        }
    }, [editTime])

    const handleChangeHour = (event) => {
        if (event.target.value === "") {
            return
        }
        const newValue = event.target.value;
        if (IsHourValueValid(newValue) && IsHourValueValid(newValue)) {
            setHour(newValue)
        }
    };

    const handleChangeMinutes = (event) => {
        if (event.target.value === "") {
            return
        }
        const newValue = event.target.value;
        if (IsValueValid(newValue) && IsMinuteValueValid(newValue)) {
            setMinutes(newValue);
        }
    };

    const IsValueValid = (value) => {
        // check if value is int and the length is not more than 2 characters
        if ((/^\d*$/.test(value) && value.length <= 2)) {
            return true;
        } else {
            return false
        }
    }

    const IsHourValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value <= 23) {
            return true;
        }
    }

    const IsMinuteValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value < 60) {
            return true;
        } else {
            return false
        }
    }

    const getValueLength = (value) => {
        const numberAsString = value.toString(); // Convert number to string
        const numberLength = numberAsString.length;
        if (numberLength < 2) {
            return true
        } else {
            return false;
        }

    }

    const DeleteSchedule = () => {

    }
    //-------------------------------------------------------------------------------------------


    //if newValue < 10 0 + newValue || if newValue >


    //to change the background colour of the removebutton when hovering over it.
    const [onMouseEnterRemove, setOnMouseEnterRemove] = useState()

    return (
        <div>
            <div className={classes.verticalFlex}>
                <div className={classes.verticalFlex}>
                    <div className={classes.verticalFlex}>
                        {!editTime ? <h2 onClick={() => setEditTime((prevEditTime) => !prevEditTime)} style={{ margin: "5.8px", fontWeight: "500", cursor: "pointer", color:"#6e6e6e", fontSize:"30px"}}>{hour + ":" + minutes || "12:00"}</h2> :
                            <div className={classes.horizontalFlex} style={{ position: "relative" }}>
                                <RoundedInput value={hour} onChange={handleChangeHour} placeholder={hour || "12"} />
                                :
                                <RoundedInput value={minutes} onChange={handleChangeMinutes} placeholder={minutes || "00"} />
                                <div style={{ position: "absolute", left: "450px", bottom: "30px", textAlign: "center", borderRadius: "50%", border: "1px solid grey", width: "20px", height: "fit-content", cursor: "pointer" }} onClick={() => setEditTime(false)}>X</div>
                            </div>
                        }
                    </div>
                </div >

                <div className={classes.verticalFlex}>
                    <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color:"#6e6e6e" }}>Repeat:</h4>
                    <ul className={classes.horizontalFlex}>
                        {["0", "1", "2", "3", "4", "5", "6"].map((dayIndex, index) => (

                            <li key={index}>
                                <Button2 style={{ backgroundColor: daysSelected.find(Day => Day == dayIndex) && "var(--Primary-Color)", color: daysSelected.find(Day => Day == dayIndex) && "white", minWidth:"60px", minHeight:"30px" }} onClick={() => HandleOnDayClicked(dayIndex)}>{Days[dayIndex]}</Button2>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={classes.verticalFlex} style={{ gap: "15px" }}>
                    <div style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: "15px" 
                        }}>
                        <Button2 
                            style={{ minWidth: "300px", marginTop: "20px" }} 
                            disabled={daysSelected.length === 0} 
                            className={SaveButtonclass.SaveButton} 
                            onClick={HandelOnClick}>
                            {"Update schedule"}
                        </Button2>

                           <Button2 
                                onMouseEnter={() => setOnMouseEnterRemove(true)} 
                                onMouseLeave={() => setOnMouseEnterRemove(false)} 
                                style={{ backgroundColor: onMouseEnterRemove ? "red" : "#FF5a5a", marginTop:"10px" }} 
                                onClick={DeleteSchedule}>
                                {"Remove schedule"}
                            </Button2>
                       

                        
                    </div>
                </div>
            </div >
        </div>
    )
})

export default EditScheduledAction